import { render, staticRenderFns } from "./AboutUs_NL.vue?vue&type=template&id=36c1334e&scoped=true&"
import script from "./AboutUs_NL.vue?vue&type=script&lang=js&"
export * from "./AboutUs_NL.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_NL.vue?vue&type=style&index=0&id=36c1334e&prod&lang=css&"
import style1 from "./AboutUs_NL.vue?vue&type=style&index=1&id=36c1334e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1334e",
  null
  
)

export default component.exports